export const REPLY_INDENT_CLASS = "pl-[3.25rem]";
export const REPLY_INPUT_ALIGN_CLASS = "pl-10";
export const LINK_BUTTON_CLASS =
  "px-0 text-xs text-gray-500 underline underline-offset-2";
export const COMMENT_LIST_GRID_CLASS = "grid min-w-0 grid-cols-[3.1875rem_1fr]";
